import { render, staticRenderFns } from "./ClaimsSearch.vue?vue&type=template&id=f3100af4&scoped=true"
import script from "./ClaimsSearch.vue?vue&type=script&lang=js"
export * from "./ClaimsSearch.vue?vue&type=script&lang=js"
import style0 from "./ClaimsSearch.vue?vue&type=style&index=0&id=f3100af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3100af4",
  null
  
)

export default component.exports